// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { TaskFrequency_abstract } from './../abstract/SagaSchema/TaskFrequency_abstract';
export class TaskFrequency extends TaskFrequency_abstract {}
